import React, { useState, useEffect } from 'react';
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';
import ArrowBackIosIcon from '@mui/icons-material/ArrowBackIos';

import Slider1 from './Images/Slider1.jpg';
import Slider2 from './Images/Slider2.jpg';
import Slider3 from './Images/Slider3.jpg';

const ImageSlider = () => {
  const slides = [
    { image: Slider3 },
    { image: Slider2 },
    { image: Slider1 },
  ];

  const [current, setCurrent] = useState(0);
  const length = slides.length;

  const nextSlide = () => {
    setCurrent(current === length - 1 ? 0 : current + 1);
  };

  const prevSlide = () => {
    setCurrent(current === 0 ? length - 1 : current - 1);
  };

  if (!Array.isArray(slides) || slides.length <= 0) {
    return null;
  }

  return (
    <section style={styles.slider}>
      <ArrowBackIosIcon style={styles.leftArrow} onClick={prevSlide} />
      <ArrowForwardIosIcon style={styles.rightArrow} onClick={nextSlide} />
      {slides.map((slide, index) => (
        <div
          style={{
            ...styles.slide,
            ...(index === current ? styles.activeSlide : {}),
          }}
          key={index}
        >
          {index === current && (
            <img
              src={slide.image}
              alt="travel image"
              style={styles.image}
              loading="lazy"
            />
          )}
        </div>
      ))}
    </section>
  );
};

const styles = {
  slider: {
    position: 'relative',
    height: '90vh',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    overflow: 'hidden',
    padding: '0 20px', // some horizontal padding for smaller devices
  },
  image: {
    width: '100%',
    maxWidth: '1000px',
    height: 'auto',
    maxHeight: '80vh',
    borderRadius: '10px',
    objectFit: 'cover',
    boxShadow: '0 4px 8px rgba(0,0,0,0.2)',
  },
  rightArrow: {
    position: 'absolute',
    top: '50%',
    right: '16px',
    fontSize: '2.5rem',
    color: '#000',
    zIndex: 10,
    cursor: 'pointer',
    userSelect: 'none',
    transform: 'translateY(-50%)',
  },
  leftArrow: {
    position: 'absolute',
    top: '50%',
    left: '16px',
    fontSize: '2.5rem',
    color: '#000',
    zIndex: 10,
    cursor: 'pointer',
    userSelect: 'none',
    transform: 'translateY(-50%)',
  },
  slide: {
    opacity: 0,
    transition: 'opacity 1s ease',
    position: 'absolute',
    width: '100%',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
  activeSlide: {
    opacity: 1,
    transform: 'scale(1.08)',
    transition: 'opacity 1s ease, transform 1s',
    position: 'relative',
  },
};

export default ImageSlider;
